import React, { useState, useEffect, memo } from "react";
import PropTypes from "prop-types";
import { usePrevious } from "../../utilities/hooks";
import { IE11 } from "../../constants/";

/**
 * @name CustomCheckbox
 * @function
 * @description Displays a checkbox
 * @returns {JSX}
 * @param {*} props
 */
function CustomCheckbox(props) {
  const [checked, setChecked] = useState(props.checked),
    [value, setValue] = useState(props.value),
    prevChecked = usePrevious(props.checked);

  useEffect(() => {
    if (prevChecked !== props.checked) setChecked(props.checked);

    return () => {
      // check for change in values
      if (props.value !== value) {
        setValue(props.value);
        setChecked(props.checked);
      }
    };
  });

  let classes = ["checkbox"];

  if (IE11) classes.push("ie11");

  if (props.className) classes.push(props.className);

  return (
    <div className={classes.join(" ")}>
      <input
        className = {props.customClass}
        id={props.id}
        type="checkbox"
        value={props.value}
        checked={props.checked}
        onChange={props.onChange}
        data-filter-id={props.datafilterid}
        name={props.name}
        data-value={props.datavalue}
      />
      <label
        htmlFor={props.id}
        dangerouslySetInnerHTML={{ __html: props.label }}
        title={props.title}
        aria-labelledby={props.id}
        role="group"
      />
    </div>
  );
}

CustomCheckbox.defaultProps = {
  checked: false,
  disabled: false,
  value: "",
};

CustomCheckbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  title: PropTypes.string,
};

export default memo(CustomCheckbox);
